export default __webpack_public_path__ + "static/media/rout.863ce828.png";